class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

// document.addEventListener('DOMContentLoaded', function () {
//   const searchCards = document.querySelectorAll('.product-card-wrapper .quick-add__submit');

//   searchCards.forEach(button => {
//     button.addEventListener('click', function (e) {
//       const form = button.closest('form');
//       const productUrl = button.getAttribute('data-product-url');

//       if (!form) return;

//       // check if multi-variant
//       const isMultiVariant = button.closest('.modal-opener') ? true : false;

//       if (isMultiVariant) {
//         // Multi-variant -> redirect to product page
//         window.location.href = productUrl;
//         e.preventDefault();
//         return;
//       }

//       e.preventDefault();

//       // Trigger Dawn Quick Add
//       if (window.theme && theme.QuickAdd) {
//         const quickAddInstance = new theme.QuickAdd(form);
//         quickAddInstance.openDrawer(); // open cart drawer
//         quickAddInstance.submitForm(); // add product to cart
//       } else {
//         // fallback
//         form.submit();
//       }

//       // Tick mark + Added text
//       button.innerHTML = '<span>✔ Added</span>';
//     });
//   });
// });


